import { httpRequest } from '../../shared/lib/utils/httpClient';

export interface ConsultItem {
  consultId: number;
  partnerName: string;
  facilityName: string;
  patientFirstName: string;
  patientLastName: string;
  dob: string;
  mrn: string;
  callBackNumber: string;
  unitDepartment: string;
  cart: string;
  reason: string;
  sessionStatus: string;
  requestedOn: string;
  createdBy: number;
  acceptedProviderId: number;
  providerFirstName: string;
  providerLastName: string;
  modifiedOn: string;
  waitEndTime: string;
  acceptedOn: string;
  requestedByOthers: boolean;
  unreadMessageCount: number;
  isExternalConsult: boolean;
  isCustomUrl: boolean;
}

export interface ConsultResponse {
  requestedByMeCount: number;
  requestedByOthersCount: number;
  requestedByMe: ConsultItem[];
  requestedByOthers: ConsultItem[];
}

export interface GeneralType {
  id: number;
  name: string;
}

export interface PartnerFacilitiesType {
  partnerId: number;
  partnerName: string;
  facilities: Facilities[];
}

export interface PartnerFacilityFilterResponse {
  partnerFacilitiesMap: PartnerFacilitiesType[];
  activeStatusList: GeneralType[];
  pastStatusList: GeneralType[];
}

export interface Facilities {
  id: number;
  checked: boolean;
  name: string;
}

export interface IndeterminateCheckboxFacilityProps {
  partnerName: string;
  partnerId: number;
  checked: boolean;
  facilities: Facilities[];
  checkFacility: boolean | null;
  checkInderterminate: boolean;
}

export interface ActivateConsultResponse {
  code: number;
  status: string;
  message: string;
}

export const getCaseManagerActiveConsults = async (
  userId: number
): Promise<ConsultResponse> => {
  const response = await httpRequest<ConsultResponse>({
    url: `/facility/case-manager/${userId}/active`,
    method: 'GET',
  });
  return response;
};

export const getCaseManagerPastConsults = async (
  userId: number
): Promise<ConsultResponse> => {
  const response = await httpRequest<ConsultResponse>({
    url: `/facility/case-manager/${userId}/past`,
    method: 'GET',
  });
  return response;
};

export const getCaseManagerPartnerFacilityFilters = async (
  userId: number
): Promise<PartnerFacilityFilterResponse> => {
  const response = await httpRequest<PartnerFacilityFilterResponse>({
    url: `/facility/case-manager/filter/${userId}/partner-facilities`,
    method: 'GET',
  });
  return response;
};

export const activateConsult = async (consultId: number, userId: string) => {
  const response = await httpRequest<ActivateConsultResponse>({
    method: 'PUT',
    url: `/facility/case-manager/${consultId}/activate`,
    headers: { userId },
  });
  return response;
};
